import GLightbox from 'glightbox/src/js/glightbox.js';
import { deepAssign } from '../_utils/deepObjects.js';
const instances = [];
const create = function (name, options) {
  const existing = instances.find(data => data.name === name);
  if (existing) {
    return existing.lightbox;
  }
  options = deepAssign({
    autoplayVideos: true,
    touchNavigation: true,
    plyr: {
      config: {
        muted: true,
        hideControls: false,
        autoplay: true,
        youtube: {
          noCookie: true,
          rel: 0,
          showinfo: 0,
          iv_load_policy: 3
        }
      }
    }
  }, options);
  const lightbox = GLightbox({
    selector: '[data-lightbox="' + name + '"] a.lightbox-able',
    ...options
  });

  // Return focus on close.
  let focusedBefore = null;
  lightbox.on('open', () => {
    focusedBefore = document.activeElement;
  });
  lightbox.on('close', () => {
    if (focusedBefore) {
      focusedBefore.focus();
    }
  });
  instances.push({
    name,
    lightbox
  });
  return lightbox;
};
create.find = name => instances.find(data => data.name === name)?.lightbox;
export default create;